<template>
    <div>
        <TopHeader/>
        <div id="main-content">

            <VideoSection />
            <Rooms />
            <Foodhub />
            <LongStay />
            <Service />
<!--            <Fitness />-->
<!--            <Kids />-->
            <Faq />
            <Contact />
          <div class="contact-us-fixed">
            <a href="https://api.whatsapp.com/send?phone=380737744473">
              <img src="/img/whatsapp.svg" alt="">
            </a>
            <a href="viber://contact?number=%2B380737744473">
              <img src="/img/viber.png" alt="">
            </a>
<!--            <a href="tg://resolve?domain=+380737744473">-->
<!--              <img src="/img/telegram.png" alt="">-->
<!--            </a>-->
          </div>
          <a href="javascript: void(0)" class="back-to-top">
            <img src="/img/arrow.svg" alt="">
          </a>
        </div>
        <Footer />
        <div class="md-modal md-effect-10 modal-sidebar" id="modal-sidebar">
            <div class="md-content">
                <div class="modal-logo">
                    <img src="/img/main-logo.svg" alt="logo">
                </div>
                <ul class="mobile-menu">
                    <li class="md-li"><a href="/rooms">{{$t('navigation.rooms')}}</a></li>
                    <li class="md-li"><a :href="[lang === 'ru' ? '/booking.html' : `/booking_${lang}.html`]" data-is-disable-anchor="true">{{$t('navigation.booking')}}</a></li>
                    <li class="md-li"><a href="/food-hub">{{$t('navigation.food')}}</a></li>
                    <li class="md-li"><a href="/service">{{$t('navigation.confService')}}</a></li>
                    <li class="md-li"><a href="/contact">{{$t('navigation.contact')}}</a></li>
                    <li class="md-li"><a :href="[lang === 'en' ? '/pdf/presentation.pdf' : '/pdf/presentation_ua.pdf']" data-is-disable-anchor="true">{{$t('navigation.about')}}</a></li>
                    <li class="md-li" style="visibility:hidden;"><a href="/faq">{{$t('navigation.faq')}}</a></li>
                    <li class="md-li" style="visibility:hidden;"><a href="/long-stay">{{$t('navigation.faq')}}</a></li>
<!--                    <li class="md-li" style="visibility:hidden;"><a href="/kids">{{$t('navigation.faq')}}</a></li>-->
                </ul>
                <div class="md-close ok">
                    <img src="img/close.svg" alt="close">
                </div>
            </div>
        </div>

        <div class="md-overlay"></div>

        <ModalIndex />
    </div>
</template>

<script>
    import sassStyles from './../assets/sass/style.scss'
    import TopHeader from './sections/TopHeader'
    import VideoSection from "./sections/VideoSection";
    import MobFilter from "./sections/MobFilter";
    import Foodhub from "./sections/FoodHub";
    import Service from "./sections/Service";
    import LongStay from "./sections/LongStay";
    import Fitness from "./sections/Fitness";
    import Contact from "./sections/Contact";
    import Rooms from "./sections/Rooms";
    import Footer from "./sections/Footer";
    import ModalIndex from "./popups/Index";
    import Faq from "@/components/sections/Faq";
    import Kids from "@/components/sections/Kids";

    export default {
        name: 'Layout',
        components: {
          Fitness,
            ModalIndex,
            Contact,
            Service,
            LongStay,
            Foodhub,
            MobFilter,
            VideoSection,
            Rooms,
            Kids,
            Faq,
            Footer,
            TopHeader,
            sassStyles
        },
        props: {
            msg: String
        },
        computed: {
            lang: function() {
                return this.$root.locale;
            }
        }

    }
</script>
